import api from './index';
const endpoints = {
    rallies: '/admin/rallies',
    tasks: '/admin/tasks',
    taskAnswers: 'admin/task-answers',
    inputTaskAnswers: 'admin/input-task-answers',
};
export const getAdminTasks = async (id) => {
    const res = await api.get(`${endpoints.rallies}/${id}/tasks`);
    return res.data;
};
export const getAdminTask = async (taskId) => {
    const res = await api.get(`${endpoints.tasks}/${taskId}`);
    return res.data;
};
export const saveAdminTask = async (rallyId, body) => {
    return await api.post(`${endpoints.rallies}/${rallyId}/tasks`, body);
};
export const updateAdminTask = async (id, body) => {
    const res = await api.patch(`${endpoints.tasks}/${id}`, body);
    return res.data;
};
export const sortTasks = async (rallyId, sortedTasks) => {
    return await api.post(`${endpoints.rallies}/${rallyId}/sorting`, { sorting: sortedTasks });
};
export const sortTaskAnswers = async (taskId, sortedTaskAnswers) => {
    return await api.post(`${endpoints.tasks}/${taskId}/sorting`, { sorting: sortedTaskAnswers });
};
export const deleteAdminTask = async (id) => {
    await api.delete(`${endpoints.tasks}/${id}`);
};
export const deleteAdminTaskAnswer = async (id) => {
    await api.delete(`${endpoints.taskAnswers}/${id}`);
};
export const pasteAdminTask = async ({ rallyId, taskId }) => {
    const res = await api.post(`${endpoints.rallies}/${rallyId}/tasks/${taskId}/paste`, {});
    return res.data;
};
